/* global axios */
import ApiClient from '../ApiClient';

class IntegrationControlsAPI extends ApiClient {
  constructor() {
    super('teletel/integration-controls', { accountScoped: true });
  }

  links(kind, params = {}) {
    return axios.get(`${this.url}/${kind}`, { params });
  }

  update(kind, id, policy) {
    return axios.put(`${this.url}/${kind}/${id}`, { policy });
  }

  events(params = {}) {
    return axios.get(`${this.baseUrl()}/teletel/integration-events`, {
      params,
    });
  }
}

export default new IntegrationControlsAPI();
